/* VulkanUS Motion — Scroll-Reveal + Zahlen-Counter (einmalig, mehrfach einbindbar) */
(function () {
  if (window.__vkMotion) return;
  window.__vkMotion = true;

  var mq = window.matchMedia;
  var reduced = mq && mq('(prefers-reduced-motion: reduce)').matches;

  /* Shop-Check 16.09.2026, Punkt 33: Auf dem Handy lief die Einblendung dem Daumen
     hinterher — wer zuegig scrollt, sah kurz weisse Flaechen. Unter 861 px wird die
     Animation deshalb gar nicht mehr gestartet (dieselbe Grenze wie im CSS), alles
     steht sofort sichtbar da. Am Desktop bleibt die Einblendung, greift aber frueher. */
  var schmal = mq && mq('(max-width: 860px)').matches;

  function sofort(reveals, counters) {
    reveals.forEach(function (el) { el.classList.add('vkr-in'); });
    counters.forEach(function (el) { el.textContent = el.getAttribute('data-vk-count'); });
  }

  function init() {
    var reveals = document.querySelectorAll('[data-vkr]');
    var counters = document.querySelectorAll('[data-vk-count]');

    if (reduced || schmal || !('IntersectionObserver' in window)) {
      sofort(reveals, counters);
      return;
    }

    /* rootMargin statt negativem Rand: die Sektion wird schon 300 px vor dem
       Sichtbarwerden aufgedeckt, threshold 0 statt 0.15. Damit ist der Inhalt auch
       bei schnellem Scrollen fertig eingeblendet, bevor er in den Blick kommt. */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('vkr-in');
        io.unobserve(e.target);
      });
    }, { threshold: 0, rootMargin: '300px 0px 300px 0px' });
    reveals.forEach(function (el) { io.observe(el); });

    /* Notbremse: faellt der Observer aus (Tab im Hintergrund geladen, fremdes
       Scroll-Skript, Fehler in einer anderen Section), steht nach 1,5 s trotzdem
       alles sichtbar da, statt dauerhaft leer zu bleiben. */
    setTimeout(function () {
      document.querySelectorAll('[data-vkr]:not(.vkr-in)').forEach(function (el) {
        el.classList.add('vkr-in');
      });
    }, 1500);

    var co = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        co.unobserve(e.target);
        var el = e.target;
        var target = parseInt(el.getAttribute('data-vk-count'), 10) || 0;
        var dur = 900, start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min(1, (ts - start) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased);
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    counters.forEach(function (el) { co.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
